function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.462 0H.769A.77.77 0 000 .77v7.692c0 .424.344.769.77.769h7.692a.77.77 0 00.769-.77V.77A.77.77 0 008.46 0zM19.23 0h-7.692a.77.77 0 00-.769.77v7.692c0 .424.345.769.77.769h7.692A.77.77 0 0020 8.46V.77A.77.77 0 0019.23 0zM8.462 10.77H.769a.77.77 0 00-.769.769v7.692c0 .425.344.77.77.77h7.692a.77.77 0 00.769-.77v-7.693a.77.77 0 00-.77-.769zM19.23 10.77h-7.692a.77.77 0 00-.769.769v7.692c0 .425.345.77.77.77h7.692a.77.77 0 00.769-.77v-7.693a.77.77 0 00-.77-.769z",
  fill: "#fff",
  fillOpacity: 0.9
});

function SvgQuadMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref);
}

export default SvgQuadMenu;